import { v4 as makeUuid } from 'uuid'
import { AxiosInstance } from 'axios'
import { IUrlUtils } from 'v2/modules/lib'

export interface IAccountServiceArgs {
  httpClient: AxiosInstance
  urlUtils: IUrlUtils
}

export const makeAccountService = ({ httpClient, urlUtils }: IAccountServiceArgs) => {
  const getAccountSettings = async (accountId: string, variables: string[]): Promise<Array<Record<string, any>>> => {
    const res = await httpClient.get(`/account-service/account/${urlUtils.urlEncode(accountId)}/settings`, {
      params: {
        variables: variables.join(',')
      },
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  const saveAccountSettings = async (accountId: string, settings: Array<Record<string, any>>) => {
    const res = await httpClient.put(`/account-service/account/${urlUtils.urlEncode(accountId)}/settings`, settings, {
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  const getAccountQnsSettings = async (accountId: string): Promise<Record<string, any>> => {
    const res = await httpClient.get(`/account-service/account/${urlUtils.urlEncode(accountId)}/qns-settings`, {
      headers: {
        'X-Request-ID': makeUuid()
      }
    })
    return res.data
  }

  const saveAccountQnsSettings = async (accountId: string, settings: Record<string, any>) => {
    const res = await httpClient.put(
      `/account-service/account/${urlUtils.urlEncode(accountId)}/qns-settings`,
      settings,
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  const getDomainModifiedSettings = async (accountId: string): Promise<Record<string, any>> => {
    const res = await httpClient.get(
      `/account-service/account/${urlUtils.urlEncode(accountId)}/domain-modified-settings`,
      {
        headers: {
          'X-Request-ID': makeUuid()
        }
      }
    )
    return res.data
  }

  return Object.freeze({
    getAccountSettings,
    saveAccountSettings,
    getAccountQnsSettings,
    saveAccountQnsSettings,
    getDomainModifiedSettings
  })
}
